module.exports = __webpack_public_path__ + "static/img/14.9d08396.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/9/zh/14.png
// module id = 8lrL
// module chunks = 0